/* PP search: shared normaliser for character search (index + collections). Diacritic/case-insensitive, multi-word AND,
   LaTeX formula normalised (\cmds, ^, {}, spaces, case stripped) with compact + alias forms (E=mc^2 -> e=mc2, emc2, mass energy). */
(function () {
  'use strict';
  function fold(s) { return (s || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/ß/g, 'ss').toLowerCase(); }
  var CMD = /\\(text|mathrm|mathbf|mathit|mathcal|operatorname|vec|boldsymbol|bm|hat|bar|dot|ddot|tilde|overline|left|right|bigl|bigr|big|Big|displaystyle|tfrac|dfrac|frac|cdot|times|quad|qquad|lvert|rvert|vert|langle|rangle|mathbb)(?![a-zA-Z])/g;
  var ALIAS = [
    [/(^|[^a-z0-9])e=mc2/, 'emc2 e=mc2 mass energy equivalence relativity'],
    [/(^|[^a-z0-9])f=ma/, 'f=ma fma force mass acceleration newton second law'],
    [/f=dp\/?dt|f=pdt/, 'f=ma fma force momentum newton second law'],
    [/s=kbln|s=kln/, 'entropy boltzmann s=klnw'],
    [/ds=/, 'entropy'],
    [/e=hν|e=hnu|e=hf/, 'e=hf ehf planck photon energy'],
    [/pv=nrt|pv=nkt/, 'pv=nrt pvnrt ideal gas law'],
    [/v=ir/, 'v=ir vir ohm law'],
    [/f=gm1m2|f=gmm/, 'gravity gravitation newton inverse square']
  ];
  function tex(f) {
    var lines = fold(f).split(';;'), out = [];
    lines.forEach(function (l) {
      var a = l.replace(CMD, '').replace(/\\[,;:! ]/g, '').replace(/\\\\/g, '').replace(/\\([a-z]+)/g, '$1').replace(/[\^{}\s\\&]/g, '');
      var b = a.replace(/_\(?[a-z0-9]+\)?/g, '').replace(/_/g, '');
      [a, b].forEach(function (x) { out.push(x, x.replace(/[^a-z0-9=]/g, ''), x.replace(/[^a-z0-9]/g, '')); });
    });
    var s = out.join(' '); ALIAS.forEach(function (r) { if (r[0].test(s)) s += ' ' + r[1]; }); return s;
  }
  function hay(el) { if (el.__h == null) el.__h = fold(el.dataset.q) + ' ' + tex(el.dataset.f) + ' ' + fold(el.dataset.q).replace(/[^a-z0-9 ]/g, ''); return el.__h; }
  function terms(q) { return fold(q).replace(/[\\^{}]/g, '').split(/\s+/).filter(Boolean); }
  function match(el, T) { if (!T.length) return true; var h = hay(el); for (var i = 0; i < T.length; i++) { var t = T[i]; if (h.indexOf(t) < 0 && h.indexOf(t.replace(/[^a-z0-9]/g, '') || t) < 0) return false; } return true; }
  function debounce(fn, ms) { var t; return function () { var a = arguments, s = this; clearTimeout(t); t = setTimeout(function () { fn.apply(s, a); }, ms); }; }
  window.ppSearch = { fold: fold, tex: tex, hay: hay, terms: terms, match: match, debounce: debounce };
})();
